export default {
  // 设置页面
  PunchBoardTitle: "戳戳乐-游戏设定",
  candidatesLabel: "候选人名单",
  candidatesPlaceholder: "输入候选名字，并以逗号(,)分隔，按下Enter新增项目，最大候选数为20人",
  candidateExists: "候选人已存在",
  maxCandidates: "候选人数量已达上限 (20)",
  clearSettings: "清空设定",
  saveSettings: "保存设定"
}